// Report-param grammar for the ad-testing block: ad<key> stores the block config object as-is,
// so there is nothing to parse - only the empty-config convention to apply in both directions.
// Ported from the coffee block (importReportParams / updateReportParams).

export const resolveReportParams = ({ section } = {}) => ({ config: section || {} })

// a config that names nothing is the block being read the way it opens, and a param at its default
// is dropped rather than stored
export const calcReportParamsSection = ({ config } = {}) => (Object.keys(config || {}).length ? config : null)
